.check-all {
    margin-bottom: 16px;
}
